import React from 'react'
import { getCookies, setCookie } from 'cookies-next'

export const CookieConsent = () => {
  const [visible, setVisible] = React.useState(false)

  React.useEffect(() => {
    const consentGiven = getCookies().cookieConsent
    if (!consentGiven) {
      setVisible(true)
    }
  }, [])

  const handleAccept = () => {
    setCookie('cookieConsent', 'true', { maxAge: 60 * 60 * 24 * 365 })
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="fixed bottom-[250px] right-[16px] md:right-[31px] z-[1000] flex max-w-[320px] md:max-w-[373px] items-center gap-6 rounded-[16px] md:rounded-[24px] bg-[#f2f2f2] p-[12px] md:p-6 shadow-[0_-2px_10px_rgba(0,0,0,0.1)] box-border max-sm:right-4 max-sm:w-[343px] max-sm:p-4">
      <p className="m-0 md:text-[16px] leading-[120%] text-[#333] text-[14px]">
        Пользуясь нашим сайтом, вы соглашаетесь с тем, что{' '}
        <a
          href="/policies/cookie-mitm.pdf"
          target="_blank"
          className="text-black"
        >
          мы используем cookies
        </a>
      </p>

      <button
        onClick={handleAccept}
        type="button"
        className="whitespace-nowrap rounded-[16px] bg-black px-6 py-[18px] text-white transition-all duration-300 hover:bg-[#2a3bb5]"
      >
        Окей
      </button>
    </div>
  )
}